var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event && _vm.race)?_c('div',[_c('BadgeDetailsDialog',{ref:"badgeDetails",attrs:{"event":_vm.event,"race":_vm.race,"hideCloseButton":_vm.isEmbeddedInApp}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }